(function () {
  const initProductAccordion = (section) => {
    if (!section || section.getAttribute("data-dropdowns-initialized")) return;
    const dropdowns = section.querySelectorAll("[data-product-dropdown]");
    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector("[data-product-dropdown-toggle]");
      const content = dropdown.querySelector("[data-product-dropdown-content]");
      if (!toggle || !content) return;
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const isExpanded = toggle.classList.contains("active");
        toggle.setAttribute("aria-expanded", String(!isExpanded));
        if (!isExpanded) {
          slideDown(toggle, content, 300); // func in global.js
        } else {
          slideUp(toggle, content, 300); // func in global.js
        }
      });
    });
    section.setAttribute("data-dropdowns-initialized", "true");
  };
  document.addEventListener("shopify:section:load", (event) => {
    initProductAccordion(event.target);
  });
  initProductAccordion(document.currentScript.parentElement);
})();


(() => {
  const expressCheckoutSelector = "[data-jc-express-checkout]";

  const setButtonState = (button, isBusy, label) => {
    const labelNode = button.querySelector(".button__label");
    button.disabled = isBusy;
    button.setAttribute("aria-busy", String(isBusy));
    if (labelNode && label) {
      labelNode.textContent = label;
      labelNode.dataset.label = label;
    }
  };

  document.addEventListener("click", async (event) => {
    const button = event.target.closest(expressCheckoutSelector);
    if (!button || button.disabled) return;

    const productForm = button.closest("product-form");
    const form = productForm?.querySelector("form");
    if (!form) return;

    event.preventDefault();
    setButtonState(button, true, "Going to checkout...");

    try {
      const formData = new FormData(form);
      const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || "Unable to add this item to cart.");
      }
      window.location.assign(window.routes?.checkout_url || "/checkout");
    } catch (error) {
      console.error("Jungle Calling express checkout error:", error);
      setButtonState(button, false, "Buy now");
    }
  });
})();
